var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-control',{attrs:{"offset":_vm.offset}},[_c('div',{staticClass:"map-tree-box"},[_c('CommonTree')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }